var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "870.3px",
    height: "297.8px",
    viewBox: "0 0 870.3 297.8",
    enableBackground: "new 0 0 870.3 297.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "174.3,166.1 72.2,166.1 182.4,56 166.2,39.8 17.2,188.9 174.3,188.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "225.3,56 257.2,87.9 257.2,186.1 280,186.1 280,110.7 354.9,185.6 371,169.4 241.4,39.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M472.8,66.5c44.2-0.6,84.9,23,106.4,61.6l19.9-11.1c-25.6-46-74.1-74.1-126.7-73.3 c-25.4,0.4-50.3,7.5-71.9,20.7c-21,12.8-38.4,30.9-50.4,52.3l19.9,11.1c10.1-18,24.7-33.2,42.3-44 C430.6,72.9,451.4,66.9,472.8,66.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "676.7,103.4 716.1,64 829.7,177.6 845.8,161.5 716.1,31.8 578.4,169.4 594.5,185.6 660.5,119.6  732.5,191.5 748.6,175.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.4,
    y: 60,
    transform: "matrix(0.6966 -0.7175 0.7175 0.6966 127.9824 445.523)",
    fill: "#FFFFFF",
    width: 26.7,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.4,
    y: 34.5,
    transform: "matrix(0.4872 -0.8733 0.8733 0.4872 244.9124 508.864)",
    fill: "#FFFFFF",
    width: 26.7,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.9,
    y: 18.8,
    transform: "matrix(0.2445 -0.9696 0.9696 0.2445 359.9451 522.4384)",
    fill: "#FFFFFF",
    width: 26.7,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.8,
    y: 12.2,
    transform: "matrix(0.9999 -1.479986e-02 1.479986e-02 0.9999 -0.3258 6.9907)",
    fill: "#FFFFFF",
    width: 22.8,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.9,
    y: 18.8,
    transform: "matrix(0.962 -0.2731 0.2731 0.962 7.5391 118.4644)",
    fill: "#FFFFFF",
    width: 22.8,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.2,
    y: 36.4,
    transform: "matrix(0.8586 -0.5127 0.5127 0.8586 29.6068 206.7948)",
    fill: "#FFFFFF",
    width: 22.8,
    height: 26.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.4,
    y: 63.5,
    transform: "matrix(0.6966 -0.7175 0.7175 0.6966 52.8119 278.6324)",
    fill: "#FFFFFF",
    width: 22.8,
    height: 26.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "31.3,244.8 20.6,244.8 20.6,283.5 50,283.5 50,274.1 31.3,274.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86,252.9c-8.8,0-15.1,6.9-15.1,15.6v0.1c0,9.3,6.6,15.5,16,15.5c6,0,10.1-2.4,13-6.1l-5.8-4.8 c-2.1,2.1-4.1,3-6.6,3c-3.3,0-5.6-1.7-6.5-4.9h20c0.1-0.7,0.1-1.5,0.1-2.1C101.1,260.5,96.4,252.9,86,252.9z M80.9,266.1 c0.5-3.2,2.4-5.4,5.2-5.4c2.9,0,4.8,2.1,5.2,5.4H80.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "156.8,254.2 168.4,254.2 168.4,283.5 179.1,283.5 179.1,254.2 190.7,254.2 190.7,244.8  156.8,244.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M223.8,252.9c-9.6,0-16.5,7.1-16.5,15.6v0.1c0,8.5,6.9,15.5,16.4,15.5c9.6,0,16.5-7.1,16.5-15.6v-0.1 C240.2,260,233.3,252.9,223.8,252.9z M230,268.7c0,3.6-2.4,6.6-6.2,6.6c-3.7,0-6.4-3.1-6.4-6.7v-0.1c0-3.6,2.4-6.6,6.2-6.6 c3.7,0,6.4,3.1,6.4,6.7V268.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M282.3,269.8c0,3.3-1.9,5-4.4,5c-2.5,0-4.2-1.8-4.2-5v-16.2h-10.5v19.5c0,6.8,3.8,11,10.1,11 c4.2,0,7-2.3,8.9-4.8v4.1h10.5v-29.9h-10.5V269.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M327.6,259.6v-6h-10.5v29.8h10.5v-9.3c0-6.9,3.1-10,8.5-10h0.9v-11C332.1,252.9,329.3,255.5,327.6,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M414.8,257.3c-2-2.3-4.6-4.3-9.2-4.3c-7.1,0-13.1,5.9-13.1,15.6v0.1c0,9.5,6.1,15.5,13.2,15.5 c4.5,0,7.1-2.2,9.1-4.6v4h10.5v-40.3h-10.5V257.3z M414.9,268.6c0,4-2.7,6.8-6.1,6.8s-6.1-2.8-6.1-6.8v-0.1c0-4,2.8-6.7,6.1-6.7 s6.1,2.8,6.1,6.7V268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M463.5,252.9c-8.8,0-15.1,6.9-15.1,15.6v0.1c0,9.3,6.6,15.5,16,15.5c6,0,10.1-2.4,13-6.1l-5.8-4.8 c-2.2,2.1-4.1,3-6.6,3c-3.2,0-5.6-1.7-6.5-4.9h20c0.1-0.7,0.1-1.5,0.1-2.1C478.5,260.5,473.8,252.9,463.5,252.9z M458.3,266.1 c0.5-3.2,2.4-5.4,5.2-5.4c2.9,0,4.8,2.1,5.2,5.4H458.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "536.4,283.5 547.1,283.5 547.1,269.7 565.4,269.7 565.4,260.8 547.1,260.8 547.1,254.2  567.3,254.2 567.3,244.8 536.4,244.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M600.8,259.6v-6h-10.5v29.8h10.5v-9.3c0-6.9,3.1-10,8.5-10h0.9v-11C605.3,252.9,602.5,255.5,600.8,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M644.4,253.2c-5.1,0-8.7,0.9-12.1,2.3l2.2,7.4c2.7-1,5.1-1.7,8.2-1.7c4,0,6,1.8,6,4.9v0.5 c-1.7-0.6-4.4-1.2-7.2-1.2c-7,0-11.7,3.2-11.7,9.4v0.1c0,6,4.4,9.2,10,9.2c3.9,0,6.7-1.5,8.8-3.8v3.1H659v-17.2 c0-4.2-0.9-7.3-3.2-9.5C653.4,254.4,649.8,253.2,644.4,253.2z M648.8,272.6c0,3-2.2,4.9-5.2,4.9c-2.2,0-3.7-1.2-3.7-3.2v-0.1 c0-2.2,1.8-3.7,4.8-3.7c1.5,0,3,0.3,4.1,0.8L648.8,272.6L648.8,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M702.5,252.9c-4.2,0-7,2.4-8.9,4.9v-4.2h-10.5v29.8h10.5v-16.2c0-3.3,1.9-5,4.4-5c2.5,0,4.2,1.8,4.2,5v16.2 h10.5v-19.5C712.7,257.1,708.9,252.9,702.5,252.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "767.3,253.6 755.5,253.6 747.3,263.6 747.3,243.2 736.9,243.2 736.9,283.5 747.3,283.5  747.3,276.5 750,273.3 756.1,283.5 767.6,283.5 756.9,265.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.9,
    y: 243.2,
    fill: "#FFFFFF",
    width: 10.9,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.1,
    y: 253.6,
    fill: "#FFFFFF",
    width: 10.5,
    height: 29.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M853.1,269.3c0-8.8-4.8-16.3-15.1-16.3c-8.8,0-15.1,6.9-15.1,15.6v0.1c0,9.3,6.6,15.5,16,15.5 c6,0,10.1-2.4,13-6.1l-5.8-4.8c-2.2,2.1-4.1,3-6.6,3c-3.2,0-5.6-1.7-6.5-4.9h20C853.1,270.7,853.1,269.9,853.1,269.3z M832.9,266.1 c0.6-3.2,2.4-5.4,5.2-5.4c2.9,0,4.8,2.1,5.2,5.4H832.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.10ebc0051e2e160659565bed64b8fd9c.svg";
export { ForwardRef as ReactComponent };